module.exports = __webpack_public_path__ + "img/img2.9b57a843.jpg";